export const footerBranding = {
  enabled: process.env.REACT_APP_SHOW_FOOTER_BRANDING !== "false",
  agencyName: "Nex Automations",
  agencyUrl: "https://nex-automations.com",
};
